module.exports = __webpack_public_path__ + "static/media/kodos-award-icon.e4ececd9.svg";